// extracted by mini-css-extract-plugin
export default {"posts":"Inicio_posts__aG00T"};